import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EarthEuropeAfricaFilled"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.4934 6.20375 17.7962 1.50661 12 1.5ZM3 12C3.00243 9.10631 4.39826 6.39085 6.75 4.70476V6.75001C6.75 7.16423 7.08579 7.50001 7.5 7.50001H10.0365C10.3205 7.49986 10.5801 7.33931 10.707 7.08526L11.25 6.00001H14.25V10.5H9.927C9.81065 10.4999 9.69588 10.5269 9.59175 10.5788L7.16475 11.793C6.9107 11.92 6.75015 12.1795 6.75 12.4635V15.2423C6.74989 15.5492 6.93676 15.8252 7.22175 15.939L10.5 17.25L11.118 20.955C6.51447 20.4964 3.00609 16.6263 3 12ZM16.5 19.782V17.25L17.8162 15.276C17.9333 15.1002 17.9709 14.8832 17.9198 14.6783L17.25 12V9.75H20.7038C21.7372 13.6602 20.0123 17.7766 16.5 19.782Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EarthEuropeAfricaFilled.vue"]]);
